export default "https://cdn-static.gokick.com/assets/27898be65df9afd7cb19e5714fb6a6df6232ba84/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";